import { render, staticRenderFns } from "./TimetableTemplateCreate.vue?vue&type=template&id=5ed5b112&scoped=true"
import script from "@/controllers/custom/timetable_template/timetable-template-create.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/timetable_template/timetable-template-create.js?vue&type=script&lang=js&external"
import style0 from "./TimetableTemplateCreate.vue?vue&type=style&index=0&id=5ed5b112&prod&lang=css"
import style1 from "./TimetableTemplateCreate.vue?vue&type=style&index=1&id=5ed5b112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5b112",
  null
  
)

export default component.exports